/* Importing the node modules, child components, services and controllers used 
   inside SuccessModal component */
const QuoteSuccessModal = () => {
  return (
    <div className="modal fade savesearch" id="quoteSuccessModal" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content rm-border-radius">
          <div className="modal-header">
            <button
              type="button"
              className="close btn"
              data-dismiss="modal"
              aria-label=""
            >
              <i className="bi bi-x"></i>
            </button>
          </div>
          <div className="modal-body">
            <h2 className="fw-600">Thank You!</h2>
            <p>
              {" "}
              We’ve received your request. We’re working on reserving your unit
              and will get back to you shortly!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default QuoteSuccessModal;
